import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getCareCitiesList
 * @param pageNo, searchText, stateName
 * @description This function  will fetch the lab list.
 */
export const getCareCitiesList = (pageNo, perPage) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/care_cities?page=${pageNo}&perpage=${perPage}`;

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function addUpdateCareCity
 * @param pageNo, searchText, stateName
 * @description This function  will fetch the lab list.
 */
export const addUpdateCareCity = params => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/care_cities${
    params.id ? `/${params.id}` : ""
  }`;
  if (params.id) {
    return axios.put(url, params, {
      headers: getAuthHeaders()
    });
  } else {
    return axios.post(url, params, {
      headers: getAuthHeaders()
    });
  }
};

/**
 * @function getCareCitiesList
 * @param pageNo, searchText, stateName
 * @description This function  will fetch the lab list.
 */
export const deleteCity = id => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/care_cities/${id}`;
  return axios.delete(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function updateCityOrder
 
 * @description This function  will fetch the lab list.
 */
export const updateCityOrder = params => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/care_cities/${params.id}`;
  return axios.put(url, params, {
    headers: getAuthHeaders()
  });
};
